module.exports = __webpack_public_path__ + "img/logo_black.34d6022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_black.svg
// module id = 6C3a
// module chunks = 1